import _map from 'lodash/map';
import _uniqWith from 'lodash/uniqWith';
import _find from 'lodash/find';
import _every from 'lodash/every';
import _reject from 'lodash/reject';
import _head from 'lodash/head';
import _split from 'lodash/split';
import APPCONFIG from '../../constants/Config';
import { EVENT_HEAD } from '../../constants/WsEvents';
import {
  ASYNC_OP_STATUS_SUCCESS,
  ASYNC_OP_STATUS_ERROR,
  WS_TOPIC_CUSTOMERS,
  WS_TOPIC_SCENARIOS,
  WS_TOPIC_PLANNINGS,
  WS_TOPIC_CONFIG,
  WS_TOPIC_SLAVES,
} from '../../constants/App';
import {
  REGISTER_ASYNC_OPERATION,
  PURGE_ASYNC_OPERATIONS,
  TIMEOUT_ASYNC_OPERATION,
  WS_RECEIVED_ASYNC_RESULT,
  WS_RECEIVED_OPERATION,
} from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.asyncOperations;
const asyncOperations = (state = initialSettings, action) => {
  let wsPayload;
  let resourceKey;
  let asyncOperation;
  let devicesSyncStatus;
  let status;
  let globalStatus;
  switch (action.type) {
    case REGISTER_ASYNC_OPERATION:
      return {
        ...state,
        list: _uniqWith([...state.list, action.asyncOperation], (arrAsyncOperation, othAsyncOperation) => {
          const arrTargetKey = arrAsyncOperation.targetKey;
          const othTargetKey = othAsyncOperation.targetKey;
          return (arrAsyncOperation[arrTargetKey] === othAsyncOperation[othTargetKey] && arrAsyncOperation.id === othAsyncOperation.id);
        }),
      };
    case PURGE_ASYNC_OPERATIONS:
      return {
        ...state,
        list: _reject(state.list, ['targetKey', action.targetKey]),
      };
    case TIMEOUT_ASYNC_OPERATION:
      return {
        ...state,
        list: _reject(state.list, ['id', action.asyncOperationId]),
      };
    // Treat RECEIVED_ASYNC_RESULT operations from webSocket
    case WS_RECEIVED_ASYNC_RESULT:
      asyncOperation = action.asyncOperation;
      return {
        ...state,
        list: _map(state.list, (ao) => (ao.id === action.id ? { ...ao, ...asyncOperation } : ao)),
      };
    // Treat HEAD operations from webSocket
    case WS_RECEIVED_OPERATION:
      if (action.topic && action.payload && action.operation === EVENT_HEAD) {
        wsPayload = action.payload;
        resourceKey = null;
        switch (_head(_split(action.topic, ':'))) {
          case WS_TOPIC_CUSTOMERS:
            resourceKey = 'idCustomer';
            break;
          case WS_TOPIC_PLANNINGS:
            resourceKey = 'idPlanning';
            break;
          case WS_TOPIC_SCENARIOS:
            resourceKey = 'idScenario';
            break;
          case WS_TOPIC_CONFIG:
            resourceKey = 'idConfig';
            break;
          case WS_TOPIC_SLAVES:
            resourceKey = 'idSlave';
            break;
          default:
            break;
        }
        if (resourceKey) {
          // Try to find an async operation corresponding with the resource
          asyncOperation = _find(state.list, [resourceKey, wsPayload.id]);
          if (asyncOperation) {
            // For each device concerned by this async operation,
            // update status according to async operation id sent in sync_status
            devicesSyncStatus = _map(asyncOperation.devices, (d) => {
              status = wsPayload.sync_status[d.device_id] >= asyncOperation.id ? ASYNC_OP_STATUS_SUCCESS : ASYNC_OP_STATUS_ERROR;
              return {
                ...d,
                status,
                code: status === ASYNC_OP_STATUS_SUCCESS ? 0 : d.code,
                desc: status === ASYNC_OP_STATUS_SUCCESS ? 'Synchro' : d.desc,
              };
            });
            // Compute global status according to devices sync status
            globalStatus = _every(devicesSyncStatus, ['status', ASYNC_OP_STATUS_SUCCESS]) ? ASYNC_OP_STATUS_SUCCESS : ASYNC_OP_STATUS_ERROR;
            // The async operation is in error => update its devices sync status
            if (globalStatus === ASYNC_OP_STATUS_ERROR) {
              return {
                ...state,
                list: _map(state.list, (ao) => (ao.id === asyncOperation.id
                  ? {
                    ...ao,
                    status: ASYNC_OP_STATUS_ERROR,
                    devices: devicesSyncStatus,
                  } : ao
                )),
              };
            }
            // The async operation is in success: we can delete it from state
            return {
              ...state,
              list: _reject(state.list, ['id', asyncOperation.id]),
            };
          }
          return state;
        }
        return state;
      }
      return state;
    default:
      return state;
  }
};

export default asyncOperations;



// WEBPACK FOOTER //
// ./reducers/asyncOperation/asyncOperation.js